import React from "react";
import qs from "query-string";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { List } from "./index";
import { SystemProvider } from "../../../features/system/provider";
import { USE_PAGINATION_API, SORT_OPTIONS, STATE_KEY } from "../config";
import { CollectionList } from "../../../features/collection/components/collection-list";
import { organizationsActions as actions } from "../../../features/organizations/slice";
const {
  setPageItems,
  setStatus,
  setCurrentPage,
  setSorter,
  fetchOrganizations: fetcher
} = actions

/**
 * @glossary
 * - data: post type's bulk data
 * - pageItems: chunk of bulk data to be rendered, per page
 */

const PaginatedList = ({ query, defaultData }) => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [data, setData] = React.useState(defaultData);
  const {
    itemsPerPage,
    pageItems,
    totalItems,
    status,
    currentPage,
  } = useSelector((state) => state[STATE_KEY]);

  const handleCurrentPageChange = (newCurrentPage) => {
    if (newCurrentPage !== currentPage) {
      dispatch(setCurrentPage(newCurrentPage)).then((res) => {
        if (status !== "loading") {
          const limit = itemsPerPage;
          const offset = (res.payload - 1) * itemsPerPage;
          dispatch(fetcher({ ...query, limit, offset }));
        }
      });
    }
  };

  // If with API Pagination
  const handleSorterChange = (newSorter) => {
    console.log({newSorter})
    dispatch(setSorter(newSorter)).then((res) => {
      const value = res.payload.value;
      let translated = false;

      if (value === "oldest") {
        translated = "asc";
      } else if (value === "newest") {
        translated = "desc";
      }

      else if (value === "az") {
        translated = "asc";
      } else if (value === "za") {
        translated = "desc";
      }

      if (translated) {
        const limit = itemsPerPage;
        const offset = (currentPage - 1) * itemsPerPage;

        const cloned = {...query}
        if (cloned.date) delete cloned.date
        if (cloned.name) delete cloned.name
        if (cloned.title) delete cloned.title
        if (cloned.sort_by_title) delete cloned.sort_by_title

        const finalKey = newSorter.key === 'title' ? 'sort_by_title' : newSorter.key

        const newQuery = { ...cloned, limit, offset, [finalKey]: translated };

        const searchString = qs.stringify(newQuery);
        const currentPath = location.pathname;

        history.replace({
          pathname: currentPath,
          search: "?" + searchString,
        });
      }
    });
  };

  return (
    <>
      <CollectionList
        query={query}

        sortOptions={SORT_OPTIONS}
        setSorter={handleSorterChange}

        withPaginationAPI={USE_PAGINATION_API}
        itemsPerPage={itemsPerPage}
        totalData={totalItems}
        defaultCurrentPage={currentPage}
        setPageItems={setPageItems}
        setCurrentPage={handleCurrentPageChange}

        setStatus={setStatus}
        data={data}
        setData={setData}
      >
        {pageItems && (
          <SystemProvider>
            <List data={pageItems} />
          </SystemProvider>
        )}
      </CollectionList>
    </>
  );
};

export default PaginatedList;
